import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid} from "@mui/material";
import Typed from "react-typed";
import greenTik from "assets/img/greenTik.svg";
import redTik from "assets/img/redTik.svg";
import {styled} from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import styles from 'assets/jss/Scan/scanStyle';
import nfcGif from 'assets/gif/dash-gif.gif';
import {dateCorrectionLevels} from 'helpers/scanLevels';

const useStyles = makeStyles(styles)
const CustomizedDialog = styled(Dialog)`
  & .MuiDialog-paper {
    width: 315px;
    background: #f5f5f5;
    border: 1px solid #ffffff;
    box-shadow: 8px 8px 20px rgba(172, 172, 172, 0.5), -8px -8px 20px #ffffff;
    border-radius: 16px;
    padding: 26px 24px 34px;
  }

  & .MuiBackdrop-root {
    background-color: rgba(216, 216, 216, 0.3);
    backdrop-filter: blur(6.7957px);
  }
  & .MuiDialogContent-root{
    padding: 0 10px 20px 10px;
  }
`;


const ScanModalDateCorrection = (props) => {
    const {dateState, open, setOpen, handleCorrect} = props
    const classes = useStyles()

    const handleClose = () => {
        setOpen(false);
    };
    const onCloseClick = (event, reason) => {
        if (reason && reason === 'backdropClick') return;
        handleClose();
    };


    return (
        <CustomizedDialog
            open={open}
            onClose={onCloseClick}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
        >
            {dateState === dateCorrectionLevels.INITIAL_STATES ? (
                <div>
                    <DialogTitle className={classes.dialogText} id='alert-dialog-title'>
                        {'توجه کنید!'}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            className={classes.dialogLongText}
                            id='alert-dialog-description'
                        >
                            ساعت یا تاریخ دستگاه قند خون بیمار به روز نیست، برای به روز رسانی
                            آن، دکمه زیر را فشار دهید و دوباره دستگاه را به پشت موبایل
                            بچسبانید…
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className={classes.buttonContainer}>
                        <Button className={classes.dialogFirstButton} onClick={handleCorrect}>
                            به روز رسانی تاریخ و ساعت دستگاه
                        </Button>
                    </DialogActions>
                </div>
            ) : dateState === dateCorrectionLevels.CORRECTION_REQUIRED ? (
                <div>
                    <img
                        loop
                        src={nfcGif}
                        width={'150px'}
                        height={'150px'}
                        autoPlay
                        playsInline
                        muted
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            margin: 'auto',
                            height: '200px',
                            width: '200px',
                            marginBottom: '20px',
                        }}
                    />
                    <Typed
                        strings={['دستگاه را دوباره به پشت موبایل خود بچسبانید...']}
                        typeSpeed={40}
                        className={classes.DialogNFCText}
                        showCursor={false}
                    />
                </div>
            ) : dateState === dateCorrectionLevels.CORRECTION_DATE_OK ? (
                <div>
                    <DialogTitle className={classes.dialogText} id='alert-dialog-title'>
                        <p className={classes.scanText}>اسکن دستگاه تست قند خون</p>
                    </DialogTitle>
                    <DialogContent>
                        <Grid display='flex' justifyContent='center' mt='80px' mb='80px'>
                            <img className={classes.greenTick} src={greenTik}/>
                        </Grid>
                        <DialogContentText
                            className={classes.dialogSuccessText}
                            id='alert-dialog-description'
                        >
                            تاریخ و ساعت دستگاه شما به روز شد.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className={classes.buttonContainer}>
                        <Button className={classes.dialogButton} onClick={handleClose}>
                            بازگشت
                        </Button>
                    </DialogActions>
                </div>
            ) : (
                <div>
                    <DialogTitle className={classes.dialogText} id='alert-dialog-title'>
                        <p className={classes.scanRedText}>اسکن دستگاه تست قند خون ناموفق</p>

                    </DialogTitle>
                    <DialogContent>
                        <Grid display='flex' justifyContent='center' mt='32px' mb='32px'>
                            <img className={classes.greenTick} src={redTik}/>
                        </Grid>
                        <DialogContentText
                            className={classes.dialogErrorText}
                            id='alert-dialog-description'
                        >
                          به روز رسانی تاریخ و یا ساعت دستگاه ناموفق بود!
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className={classes.buttonContainerButtons}>
                        <Button className={classes.dialogButtonDoubel} onClick={handleCorrect}>
                            اسکن مجدد
                        </Button>
                        <Button style={{color: '#D81D5D'}} className={classes.dialogButtonDoubel}
                                onClick={handleClose}>
                            لغو
                        </Button>
                    </DialogActions>
                </div>
            )}
        </CustomizedDialog>
    )
}
export default ScanModalDateCorrection